export default "__VITE_ASSET__bLCD3qDp__"